import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import * as util from '../../core/helpers/utility'
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Constants } from '../helpers/constants';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private router: Router, private _cookieService: CookieService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Skip authentication for external API calls (like ChatGPT)
        if (this.isExternalApiCall(request.url)) {
            return next.handle(request);
        }

        const currentUser = util.getActiveUser();
        if (currentUser && currentUser.authToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.authToken}`,
                },
            });
        }
        else if (Constants.TMP_AUTH_KEY in localStorage) {
            var authKey = localStorage.getItem(Constants.TMP_AUTH_KEY)
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authKey}`,
                },
            });
        }
        return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
    }

    private isExternalApiCall(url: string): boolean {
        // Check if the URL is an external API call (not to our backend)
        return url.includes('cors-anywhere.herokuapp.com') || 
               url.includes('api.openai.com') ||
               url.includes('openai.com') ||
               !url.includes(environment.apiBaseUrl);
    }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401 || err.status === 403) {
            //this.router.navigateByUrl(`/account/login`);
            this._cookieService.delete('AuthToken', '/', environment.cookieDomain);
            this._cookieService.delete('FfmUserId', '/', environment.cookieDomain);
            this._cookieService.delete('PrsprUserId', '/', environment.cookieDomain);
            this._cookieService.delete('CurrentInstance', '/', environment.cookieDomain);
            const preservedLang = localStorage.getItem(Constants.LS_LANGUAGE);
            const preservedThemeMode = localStorage.getItem(Constants.LS_THEME_MODE);
            const preservedDensityMode = localStorage.getItem(Constants.LS_DENSITY_MODE);
            const preservedSidebarSize = localStorage.getItem(Constants.LS_SIDEBAR_SIZE);
            localStorage.clear();
            if (preservedLang) {
                localStorage.setItem(Constants.LS_LANGUAGE, preservedLang);
            }
            if (preservedThemeMode) {
                localStorage.setItem(Constants.LS_THEME_MODE, preservedThemeMode);
            }
            if (preservedDensityMode) {
                localStorage.setItem(Constants.LS_DENSITY_MODE, preservedDensityMode);
            }
            if (preservedSidebarSize) {
                localStorage.setItem(Constants.LS_SIDEBAR_SIZE, preservedSidebarSize);
            }
            const loginUrl = new URL(environment.loginFrontendUrl, window.location.href);
            if (preservedLang) {
                loginUrl.searchParams.set('lang', preservedLang);
            }
            const inst = (localStorage.getItem(Constants.LS_CURRENT_INSTANCE) || '').toLowerCase();
            if (inst === 'ffm' || inst === 'prspr' || inst === 'cpjp') {
                loginUrl.searchParams.set('inst', inst);
            }
            window.location.href = loginUrl.href;
            return of(err.message);
        }
        return throwError(err);
    }
}
